module.exports = __webpack_public_path__ + "static/paragon_med-0b2461f406db10c27f6fc91900f62583.png";